import { render, staticRenderFns } from "./PlanningInfoCard.vue?vue&type=template&id=52c06f79&"
import script from "./PlanningInfoCard.vue?vue&type=script&lang=js&"
export * from "./PlanningInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports